import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as style from './ModalBody.styl';
export class ModalBody extends React.Component {
    render() {
        return _jsx("div", Object.assign({ className: style.global + (this.props.scrollable ? ' overflow-scroll' : '') }, { children: this.props.children }));
    }
}
